export const API_TIMEOUT = 60 * 1000;
export const BUYER = 'Buyer';
export const ENV = {
  local: 'local',
  testing: 'testing',
  staging: 'staging',
  production: 'production',
};



// WEBPACK FOOTER //
// ./src/common/config/variables.js